import React, { useEffect } from "react";
import PropTypes from "prop-types";

import RenderFields from "Components/RenderFields";
import { getOptionValue } from "common/enums";

import { onlyNumberKeys } from "utils";

export const inputFields = {
  // 1 Phase LT Smart Meter Reading
  101: [
    {
      label: "Instantaneous Voltage (V)",
      name: "instantaneousVoltageV",
      placeholder: "Enter Instantaneous Voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Instantaneous Current (A)",
      name: "instantaneousCurrentA",
      placeholder: "Instantaneous Current (A)",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Instantaneous Active Power (kW)",
      name: "instantaneousActivePowerkW",
      placeholder: "Enter Instantaneous Active Power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Cumulative Active Import Energy (kWh)",
      name: "activeImportEnergy",
      isRequired: true,
      placeholder: "Enter Cumulative Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Cumulative Active Export Energy (kWh)",
      name: "activeExportEnergy",
      isRequired: true,
      placeholder: "Enter Cumulative Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Import MD (kW)",
      name: "currentImportMD",
      isRequired: true,
      placeholder: "Enter Current Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Export MD (kW)",
      name: "currentExportMD",
      isRequired: true,
      placeholder: "Enter Current Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
  ],
  // 3 Phase WC Smart Meter Reading
  105: [
    {
      label: "R Phase Voltage (Line-1 V)",
      name: "rPhaseVoltage",
      placeholder: "Enter R phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Voltage (Line-2 V)",
      name: "yPhaseVoltage",
      placeholder: "Enter Y phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Voltage (Line-3 V)",
      name: "bPhaseVoltage",
      placeholder: "Enter B phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "R Phase Current (Line-1 A)",
      name: "rPhaseCurrent",
      placeholder: "Enter R phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Current (Line-2 A)",
      name: "yPhaseCurrent",
      placeholder: "Enter Y phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Current (Line-3 A)",
      name: "bPhaseCurrent",
      placeholder: "Enter B phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Neutral Current (NutrAL A)",
      name: "neutralCurrent",
      placeholder: "Enter Neutral Current (NutrAL A)",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Active Power (LoAd kW)",
      name: "instActivePower",
      placeholder: "Enter inst. active power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Apparent Power (LoAd kVA)",
      name: "instApparentPower",
      placeholder: "Enter inst. apparent power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Instantaneous PF (PF)",
      name: "instantaneousPF",
      placeholder: "Enter instantaneous PF",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Frequency (hZ - Fr)",
      name: "frequency",
      placeholder: "Enter Frequency",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Import Energy (IMP kW h)",
      name: "activeImportEnergy",
      isRequired: true,
      placeholder: "Enter Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Export Energy (EXP kW h)",
      name: "activeExportEnergy",
      isRequired: true,
      placeholder: "Enter Active Export Energy (EXP kW h)",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Apparent Import Energy (IMP kVA h)",
      name: "apparentImportEnergy",
      isRequired: true,
      placeholder: "Enter Apparent Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Apparent Export Energy (EXP kVA h)",
      name: "apparentExportEnergy",
      isRequired: true,
      placeholder: "Enter Apparent Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Reactive Energy (Q1 kVArh)",
      name: "reactiveEnergyQ1",
      isRequired: true,
      placeholder: "Enter Reactive Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Reactive Energy (Q2 kVArh)",
      name: "reactiveEnergyQ2",
      isRequired: true,
      placeholder: "Enter Reactive Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Reactive Energy (Q3 kVArh)",
      name: "reactiveEnergyQ3",
      isRequired: true,
      placeholder: "Enter Reactive Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Reactive Energy (Q4 kVArh)",
      name: "reactiveEnergyQ4",
      isRequired: true,
      placeholder: "Enter Reactive Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Import MD (IMP kW)",
      name: "currentImportMD",
      isRequired: true,
      placeholder: "Enter Current Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Export MD (EXP kW)",
      name: "currentExportMD",
      isRequired: true,
      placeholder: "Enter Current Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Cumulative Tamper Count (tMP r)",
      name: "cumulativeTamperCount",
      placeholder: "Enter Cumulative Tamper Count",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
  ],
  // 3 Phase LT CT Smart Meter Reading
  501: [
    {
      label: "R Phase Voltage (1-N V)",
      name: "rPhaseVoltage",
      placeholder: "Enter R phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Voltage (2-N V)",
      name: "yPhaseVoltage",
      placeholder: "Enter Y phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Voltage (3-N V)",
      name: "bPhaseVoltage",
      placeholder: "Enter B phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "R Phase Current (L1 A)",
      name: "rPhaseCurrent",
      placeholder: "Enter R phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Current (L2 A)",
      name: "yPhaseCurrent",
      placeholder: "Enter Y phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Current (L3 A)",
      name: "bPhaseCurrent",
      placeholder: "Enter B phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Neutral Current (LN A)",
      name: "neutralCurrent",
      placeholder: "Enter Neutral Current (LN A)",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Active Power (PWR kW)",
      name: "instActivePower",
      placeholder: "Enter inst. active power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Apparent Power (PWR kVA)",
      name: "instApparentPower",
      placeholder: "Enter inst. apparent power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Instantaneous PF",
      name: "instantaneousPF",
      placeholder: "Enter instantaneous PF",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Frequency (FRQ)",
      name: "frequency",
      placeholder: "Enter Frequency",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Energy (kW h)",
      name: "activeImportEnergy",
      isRequired: true,
      placeholder: "Enter Current Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Energy (kW h)",
      name: "activeExportEnergy",
      isRequired: true,
      placeholder: "Enter Current Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Import Energy (kVA h)",
      name: "apparentImportEnergy",
      isRequired: true,
      placeholder: "Enter Current Apparent Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Export Energy (kVA h)",
      name: "apparentExportEnergy",
      isRequired: true,
      placeholder: "Enter Current Apparent Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Import Energy (Q1 kVArh)",
      name: "reactiveEnergyQ1",
      isRequired: true,
      placeholder: "Enter Current Reactive Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },

    {
      label: "Current Reactive Import Energy (Q2 kVArh)",
      name: "reactiveEnergyQ2",
      isRequired: true,
      placeholder: "Enter Current Reactive Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Export Energy (Q3 kVArh)",
      name: "reactiveEnergyQ3",
      isRequired: true,
      placeholder: "Enter Current Reactive Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Export Energy (Q4 kVArh)",
      name: "reactiveEnergyQ4",
      isRequired: true,
      placeholder: "Enter Current Reactive Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Import MD (kVA)",
      name: "currentApparentImportMD",
      isRequired: true,
      placeholder: "Enter Current Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Export MD (kVA)",
      name: "currentApparentExportMD",
      isRequired: true,
      placeholder: "Enter Current Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import MD (kW)",
      name: "currentImportMD",
      isRequired: true,
      placeholder: "Enter Current Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export MD (kW)",
      name: "currentExportMD",
      isRequired: true,
      placeholder: "Enter Current Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Average Power Factor",
      name: "averagePowerFactor",
      isRequired: true,
      placeholder: "Enter Average Power Factor",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Phase Sequence",
      name: "phaseSequence",
      placeholder: "Enter phase sequence",
    },
    {
      label: "Current Active Import Peak Hour Energy TOD1 (kW h)",
      name: "currentActiveImportPeakHourEnergyMWhTOD1",
      isRequired: true,
      placeholder: "Enter Current Active Import Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Peak Hour Energy TOD5 (kW h)",
      name: "currentActiveImportPeakHourEnergyMWhTOD5",
      isRequired: true,
      placeholder: "Enter Current Active Import Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Peak Hour Energy (kW h)",
      name: "currentActiveExportPeakHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Export Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Night Hour Energy (kW h)",
      name: "currentActiveImportNightHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Import Night Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Night Hour Energy (kW h)",
      name: "currentActiveExportNightHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Export Night Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Import Set Off Energy TOD1",
      name: "activeImportSetOffEnergyTOD1",
      placeholder: "Enter Active Import Set Off EnergyTOD1",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Export Set Off Energy TOD1",
      name: "activeExportSetOffEnergyTOD1",
      placeholder: "Enter Active Export Set Off Energy TOD1",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Import Set Off Energy TOD3",
      name: "activeImportSetOffEnergyTOD3",
      placeholder: "Enter Active Import Set Off EnergyTOD3",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Export Set Off Energy TOD3",
      name: "activeExportSetOffEnergyTOD3",
      placeholder: "Enter Active Export Set Off Energy TOD3",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Rest Hour Energy (kW h)",
      name: "currentActiveImportRestHourEnergyMWh",
      placeholder: "Enter Current Active Import Rest Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Rest Hour Energy (kW h)",
      name: "currentActiveExportRestHourEnergyMWh",
      placeholder: "Enter Current Active Export Rest Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Import Energy",
      name: "hist1ActiveImportEnergy",
      placeholder: "Enter Hist 1 Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Export Energy",
      name: "hist1ActiveExportEnergy",
      placeholder: "Enter Hist 1 Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Import Energy",
      name: "hist2ActiveImportEnergy",
      placeholder: "Enter Hist 2 Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Export Energy",
      name: "hist2ActiveExportEnergy",
      placeholder: "Enter Hist 2 Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Import MD",
      name: "hist1ActiveImportMD",
      placeholder: "Enter Hist 1 Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Export MD",
      name: "hist1ActiveExportMD",
      placeholder: "Enter Hist 1 Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Import MD",
      name: "hist2ActiveImportMD",
      placeholder: "Enter Hist 2 Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Export MD",
      name: "hist2ActiveExportMD",
      placeholder: "Enter Hist 2 Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Apparent Import MD",
      name: "hist1ApparentImportMD",
      placeholder: "Enter Hist 1 Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Apparent Export MD",
      name: "hist1ApparentExportMD",
      placeholder: "Enter Hist 1 Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Apparent Import MD",
      name: "hist2ApparentImportMD",
      placeholder: "Enter Hist 2 Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Apparent Export MD",
      name: "hist2ApparentExportMD",
      placeholder: "Enter Hist 2 Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Defrauded",
      name: "currentDefrauded",
      placeholder: "Enter Current Defrauded",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Cumulative Tamper Count ()",
      name: "cumulativeTamperCount",
      placeholder: "Enter Cumulative Tamper Count",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
  ],
  // 3 Phase HT Smart Meter Reading
  505: [
    {
      label: "R Phase Voltage (1-N V)",
      name: "rPhaseVoltage",
      placeholder: "Enter R phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Voltage (2-N V)",
      name: "yPhaseVoltage",
      placeholder: "Enter Y phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Voltage (3-N V)",
      name: "bPhaseVoltage",
      placeholder: "Enter B phase voltage",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "R Phase Current (L1 A)",
      name: "rPhaseCurrent",
      placeholder: "Enter R phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Y Phase Current (L2 A)",
      name: "yPhaseCurrent",
      placeholder: "Enter Y phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "B Phase Current (L3 A)",
      name: "bPhaseCurrent",
      placeholder: "Enter B phase current",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Neutral Current (LN A)",
      name: "neutralCurrent",
      placeholder: "Enter Neutral Current (LN A)",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Active Power (PWR kW)",
      name: "instActivePower",
      placeholder: "Enter inst. active power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Inst. Apparent Power (PWR kVA)",
      name: "instApparentPower",
      placeholder: "Enter inst. apparent power",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Instantaneous PF (PF)",
      name: "instantaneousPF",
      placeholder: "Enter instantaneous PF",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Frequency (FRQ)",
      name: "frequency",
      placeholder: "Enter Frequency",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Energy (kW h))",
      name: "activeImportEnergy",
      isRequired: true,
      placeholder: "Current Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Energy (kW h)",
      name: "activeExportEnergy",
      isRequired: true,
      placeholder: "Enter Current Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Import Energy (kVA h)",
      name: "apparentImportEnergy",
      isRequired: true,
      placeholder: "Enter Current Apparent Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Export Energy (kVA h)",
      name: "apparentExportEnergy",
      placeholder: "Enter Current Apparent Export Energy",
      type: "number",
      isRequired: true,
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Import Energy (Q1 kVArh)",
      name: "reactiveEnergyQ1",
      isRequired: true,
      placeholder: "Enter Current Reactive Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },

    {
      label: "Current Reactive Import Energy (Q2 kVArh)",
      name: "reactiveEnergyQ2",
      isRequired: true,
      placeholder: "Enter Current Reactive Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Export Energy (Q3 kVArh)",
      name: "reactiveEnergyQ3",
      isRequired: true,
      placeholder: "Enter Current Reactive Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Reactive Export Energy (Q4 kVArh)",
      name: "reactiveEnergyQ4",
      isRequired: true,
      placeholder: "Enter Current Reactive Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Import MD (kVA)",
      name: "currentApparentImportMD",
      isRequired: true,
      placeholder: "Enter Current Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Apparent Export MD (kVA)",
      name: "currentApparentExportMD",
      isRequired: true,
      placeholder: "Enter Current Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import MD (kW)",
      name: "currentImportMD",
      isRequired: true,
      placeholder: "Current Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export MD (kW)",
      name: "currentExportMD",
      isRequired: true,
      placeholder: "Enter Current Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Average Power Factor",
      name: "averagePowerFactor",
      isRequired: true,
      placeholder: "Enter Average Power Factor",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Phase sequence",
      name: "phaseSequence",
      placeholder: "Enter Phase sequence",
    },
    {
      label: "Current Active Import Peak Hour Energy TOD1 (kW h)",
      name: "currentActiveImportPeakHourEnergyMWhTOD1",
      isRequired: true,
      placeholder: "Enter Current Active Import Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Peak Hour Energy TOD5 (kW h)",
      name: "currentActiveImportPeakHourEnergyMWhTOD5",
      isRequired: true,
      placeholder: "Enter Current Active Import Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Peak Hour Energy (kW h)",
      name: "currentActiveExportPeakHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Export Peak Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Night Hour Energy (kW h)",
      name: "currentActiveImportNightHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Import Night Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Night Hour Energy (kW h)",
      name: "currentActiveExportNightHourEnergyMWh",
      isRequired: true,
      placeholder: "Enter Current Active Export Night Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Import Set Off Energy TOD1",
      name: "activeImportSetOffEnergyTOD1",
      placeholder: "Enter Active Import Set Off EnergyTOD1",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Export Set Off Energy TOD1",
      name: "activeExportSetOffEnergyTOD1",
      placeholder: "Enter Active Export Set Off Energy TOD1",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Import Set Off Energy TOD3",
      name: "activeImportSetOffEnergyTOD3",
      placeholder: "Enter Active Import Set Off EnergyTOD3",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Active Export Set Off Energy TOD3",
      name: "activeExportSetOffEnergyTOD3",
      placeholder: "Enter Active Export Set Off Energy TOD3",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Import Rest Hour Energy (kW h)",
      name: "currentActiveImportRestHourEnergyMWh",
      placeholder: "Enter Current Active Import Rest Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Active Export Rest Hour Energy (kW h)",
      name: "currentActiveExportRestHourEnergyMWh",
      placeholder: "Enter Current Active Export Rest Hour Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },

    {
      label: "Hist 1 Active Import Energy",
      name: "hist1ActiveImportEnergy",
      placeholder: "Enter Hist 1 Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Export Energy",
      name: "hist1ActiveExportEnergy",
      placeholder: "Enter Hist 1 Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Import Energy",
      name: "hist2ActiveImportEnergy",
      placeholder: "Enter Hist 2 Active Import Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Export Energy",
      name: "hist2ActiveExportEnergy",
      placeholder: "Enter Hist 2 Active Export Energy",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Import MD",
      name: "hist1ActiveImportMD",
      placeholder: "Enter Hist 1 Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Active Export MD",
      name: "hist1ActiveExportMD",
      placeholder: "Enter Hist 1 Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Import MD",
      name: "hist2ActiveImportMD",
      placeholder: "Enter Hist 2 Active Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Active Export MD",
      name: "hist2ActiveExportMD",
      placeholder: "Enter Hist 2 Active Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Apparent Import MD",
      name: "hist1ApparentImportMD",
      placeholder: "Enter Hist 1 Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 1 Apparent Export MD",
      name: "hist1ApparentExportMD",
      placeholder: "Enter Hist 1 Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Apparent Import MD",
      name: "hist2ApparentImportMD",
      placeholder: "Enter Hist 2 Apparent Import MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Hist 2 Apparent Export MD",
      name: "hist2ApparentExportMD",
      placeholder: "Enter Hist 2 Apparent Export MD",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Current Defrauded",
      name: "currentDefrauded",
      placeholder: "Enter Current Defrauded",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
    {
      label: "Cumulative Tamper Count ()",
      name: "cumulativeTamperCount",
      placeholder: "Enter Cumulative Tamper Count",
      type: "number",
      onKeyDown: (e) => onlyNumberKeys(e, true),
    },
  ],
};

const meterReadingKeys = [
  "id",
  "instantaneousVoltageV",
  "instantaneousCurrentA",
  "instantaneousActivePowerkW",
  "rPhaseVoltage",
  "yPhaseVoltage",
  "bPhaseVoltage",
  "rPhaseCurrent",
  "yPhaseCurrent",
  "bPhaseCurrent",
  "neutralCurrent",
  "instActivePower",
  "instApparentPower",
  "instantaneousPF",
  "frequency",
  "phaseSequence",
  "currentActiveImportRestHourEnergyMWh",
  "currentActiveExportRestHourEnergyMWh",
  "hist1ActiveImportEnergy",
  "hist1ActiveExportEnergy",
  "hist2ActiveImportEnergy",
  "hist2ActiveExportEnergy",
  "hist1ActiveImportMD",
  "hist1ActiveExportMD",
  "hist2ActiveImportMD",
  "hist2ActiveExportMD",
  "hist1ApparentImportMD",
  "hist1ApparentExportMD",
  "hist2ApparentImportMD",
  "hist2ApparentExportMD",
  "currentDefrauded",
  "cumulativeTamperCount",
  "activeExportSetOffEnergyTOD3",
  "activeImportSetOffEnergyTOD3",
  "activeExportSetOffEnergyTOD1",
  "activeImportSetOffEnergyTOD1",
];

const MeterReading = ({
  formik,
  parentKey = "",
  initialMeterReading,
  finalMeterReading,
  isOnlyFinalReadingRequired,
}) => {
  const {
    values: {
      meter: { type },
    },
    setFieldValue,
  } = formik;

  useEffect(() => {
    meterReadingKeys.forEach((key) => {
      setFieldValue(`finalMeterReading.${key}`, finalMeterReading[key] ?? 0);
      if (!isOnlyFinalReadingRequired) {
        setFieldValue(
          `initialMeterReading.${key}`,
          initialMeterReading[key] ?? 0
        );
      }
    });
  }, [isOnlyFinalReadingRequired]);

  return (
    <RenderFields
      formik={formik}
      parentKey={parentKey}
      inputFields={
        inputFields[type] ??
        inputFields[getOptionValue("meterTypes", "Liberty 200")]
      }
    />
  );
};

MeterReading.propTypes = {
  formik: PropTypes.object,
  parentKey: PropTypes.string,
  isOnlyFinalReadingRequired: PropTypes.bool,
  initialMeterReading: PropTypes.object,
  finalMeterReading: PropTypes.object,
};

export default MeterReading;
